import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'

import './styles.scss'

type IconSize = 'xs' | 'small' | 'medium' | 'large'
type ColoMode = 'success' | 'white' | 'info'

export const Icon: FC<{
  children: ReactNode
  className?: string
  isWhiteLabeled?: boolean
  size?: IconSize
  block?: boolean
  colorMode?: ColoMode
  'data-tooltip-id'?: string
  'data-tooltip-content'?: string
}> = ({
  className = '',
  colorMode,
  isWhiteLabeled = true,
  children,
  size = 'medium',
  block,
  ...rest
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  return (
    <span
      className={`ui-icon ${className} ${isWhiteLabeled ? whiteLabel : ''} ${size} ${
        block ? 'block' : ''
      } ${colorMode || ''}`}
      {...rest}
    >
      {children}
    </span>
  )
}
